import keysTransforms from './keys';

const transforms = [...keysTransforms];

export default transforms;
